var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.385,
    height: 18.385,
    viewBox: "0 0 18.385 18.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_749",
    "data-name": "Group 749",
    transform: "translate(3821.692 3.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_61",
    "data-name": "Line 61",
    d: "M1,24H-1V0H1Z",
    transform: "translate(-3820.985 -2.985) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_60",
    "data-name": "Line 60",
    d: "M24,1H0V-1H24Z",
    transform: "translate(-3820.985 13.985) rotate(-45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8724a71d5518ccf2bf37f23f90da96ca.svg";
export { ForwardRef as ReactComponent };